import React from "react"
import { SettingsBoundary } from "./boundary"
import Settings, { ISettings } from "./views/Settings"

export const VSettings = (props: ISettings): JSX.Element => (
  <SettingsBoundary>
    <Settings {...props} />
  </SettingsBoundary>
)
